import { get_tiptap_test_data, get_cdn_doc, build_cdn_url } from '../../../../services/projectservice.js';
import React, { useState, useEffect, useMemo, useContext, useCallback  } from 'react';
import { generateHTML } from '@tiptap/html';
import { tt_extensions, TTHtml, TTJson } from './TTTemplate.jsx';
import './tiptap_viewer.css';
import { AuthContext } from '../../../../AuthContext.jsx';


export const TTDoc = ({ ttData }) => {
    const generatedHtml = useMemo(() => {
        return generateHTML(ttData, tt_extensions);
    }, [ttData]);

    return <div className="tiptap tiptapview" dangerouslySetInnerHTML={{ __html: generatedHtml }} />;
};


const TipTapViewer = () => {

  const { authToken, claims, isLoading, onLogout } = useContext(AuthContext);

    const [tiptapData, setTiptapData] = React.useState(null);
    const [loadError, setLoadError] = React.useState('');
    

    const handleLoad = (data) => {
        setTiptapData(data.data);
    }

    const handleLoadError = (error) => {
        console.error("Error loading data:", error);
        setLoadError(`Error loading data: ${error}`);
    }

    useEffect(() => {
        // get_tiptap_test_data(handleLoad, handleLoadError)
        get_cdn_doc('902d1aaa-8cfd-4bd4-831e-db0e0660b21c', handleLoad, handleLoadError)

    }, []);


    return (
        <div style={{ backgroundColor: '#DEECEB', padding: '20px' }}>
            
            {loadError && <div style={{ color: 'red' }}>{loadError}</div>}
            {tiptapData && <TTDoc ttData={tiptapData} />}

            <br></br>
            <br></br>
            <br></br>
            <br></br>

 <hr></hr>
         <h2>TipTap Data Views:</h2>
            {tiptapData && <TTHtml ttData={tiptapData} />}
            {tiptapData && <TTJson ttData={tiptapData} />}

        </div>
    )
}



export default TipTapViewer;
